import React, { useEffect, useState } from 'react';
import SelectInput from '../../../../components/Basic/Inputs/SelectWithInput';
import ProviderCommonApi from '../../../../API/provider/common-api';
import MarketAvitoApi from '../../../../API/market/avito-api';

export default function AvitoCategorySelect({
  category = '',
  searchParams = {},
  isAllCategotries = true,
  onChange = () => { },
  style,
  ...props
}) {
  const [list, setList] = useState([]);
  const [value, setValue] = useState('');
  const [isOk, setIsOk] = useState(null);

  const findCategory = (search) => {
    (isAllCategotries
      ? MarketAvitoApi.getCategories({ data: { search } })
      : ProviderCommonApi.getAvitoCategories1({ data: { categoryAvitoSearch: search, ...searchParams } })
    ).then((r) => {
      const categories = r.categories;
      setList(categories);
      if (r.matchedCategory) {
        setIsOk(true);
      } else {
        setIsOk(false);
      }
    });
  };

  const onSelect = (v) => {
    //  setValue(v);
    onChange(v);
    setIsOk(null);
  };

  const onBlur = () => {
    if (isOk) {
      onSelect(value);
      //setIsOk(null);
    }
  };

  const deleteCategory = () => {
    onChange('');
    setIsOk(null);
  };

  useEffect(() => {
    setValue(category);
  }, [category]);

  const onChangeInput = (v) => {
    if (v.length === 0) {
      //onChange('');
    }
    setValue(v);
    findCategory(v);
  };

  return (
    <SelectInput
      select={value}
      list={list}
      add={false}
      preventState={true}
      addText={'Добавить'}
      defaultText={'Без категории'}
      placeholder={'Категория авито'}
      {...props}
      width={'300px'}
      isOk={isOk}
      onBlur={onBlur}
      onChange={onChangeInput}
      onSelect={onSelect}
      deletePlace={deleteCategory}
      onFocus={(v) => findCategory(v)}
    />
  );
}
